export default __webpack_public_path__ + "static/media/pa_4.bbfbbf19.mp3";